import { ActionType, createAction } from "typesafe-actions";

import {
  EntitiesSupportedByEmailFeature,
  EntityTypesSupportedByEmailFeature,
  MapEntity,
} from "@mapmycustomers/shared/types/entity";
import MapViewState from "@mapmycustomers/shared/types/viewModel/MapViewState";

export type PinLegendsSource = Pick<MapViewState, "colorKey" | "shapeKey">;

export const fetchAnnotationData = createAction("@component/entityAnnotation/fetchAnnotationData")<{
  callback: (params: { emailSubscribed: boolean | undefined; entity: MapEntity }) => void;
  entityId: MapEntity["id"];
  entityType: MapEntity["entity"];
  failureCallback: () => void;
  pinLegendsSource?: PinLegendsSource;
}>();

export const subscribeEntityEmail = createAction(
  "@component/entityAnnotation/subscribeEntityEmail"
)<{
  callback: () => void;
  entityId: EntitiesSupportedByEmailFeature["id"];
  entityType: EntityTypesSupportedByEmailFeature;
}>();

export const unsubscribeEntityEmail = createAction(
  "@component/entityAnnotation/unsubscribeEntityEmail"
)<{
  callback: () => void;
  entityId: EntitiesSupportedByEmailFeature["id"];
  entityType: EntityTypesSupportedByEmailFeature;
}>();

export type Actions = ActionType<
  typeof fetchAnnotationData | typeof subscribeEntityEmail | typeof unsubscribeEntityEmail
>;
